<template>
  <el-menu :default-active="url" class="aside-cont navbar g-elmenu" background-color="#333743"
           active-text-color="#fff" text-color="#33CCFF" router
           :unique-opened="true" :collapse="isCollapse" style="width: 202px;font-size: 12px;height:calc(100% - 90px);">
    <template v-for="(item,index) in $router.options.routes"
              v-if="!item.hidden">

      <el-submenu :index="index+''" v-if="!item.leaf&&$checkPermissions(item.permission)">
        <template slot="title">
          <i :class="'iconfont '+ item.iconCls+' '+((netaddress===item.children[0].path&&isCollapse)?'actived':'')"></i>
          <span>{{item.name}}</span>
        </template>
        <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path"
                      v-if="!child.hidden && $checkPermissions(child.permission)"
                      @click.native="shows(child.path)">

          <span style="font-size: 13px;">{{child.name}}</span>
          <span class="remindNumBox" v-if="child.path === '/remindBill' && billRemindsCount !== 0">{{getBillRemindsCount}}</span>
          <span class="remindNumBox" v-if="child.path === '/remindOverTime' && contractRemindsCount !== 0">{{getContractRemindsCount}}</span>
        </el-menu-item>
      </el-submenu>

      <el-menu-item v-if="item.leaf && item.children.length > 0" :index="item.children[0].path"
                    :class="netaddress===item.children[0].path?'':''"
                    @click.native="shows(item.children[0].path)">
        <i :class="'iconfont '+ item.iconCls"></i><span style="font-size: 16px;">{{item.name}}</span>
      </el-menu-item>
    </template>
    <el-menu-item v-if="[283,292,289,12,50,281,261,230].includes(channelId)" @click.native="openUrl('https://www.wzjrfw.com/')">
      <i class="iconfont icon-attchment"></i><span style="font-size: 13px;">金融综合服务平台</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    data() {
      return {
        url: this.$route.path,
        query: this.$route.query.single,
        netaddress: '',
        isCollapse: false,
        billRemindsCount: 0,
        contractRemindsCount: 0,
        channelId:Number(sessionStorage.getItem('channelId')),
      }
    },
    // props: ['number', 'type', 'size', 'list'],
    created() {
    },
    mounted() {
      this.urlRedirect(this.url);
      this.init();
    },
    computed: {
      getBillRemindsCount() {
        return this.billRemindsCount;
      },
      getContractRemindsCount() {
        return this.contractRemindsCount;
      }
    },
    methods: {
      init() {
        getData.remindsCount().then(res => {
          if (res.data.code === 'success') {
            this.billRemindsCount = res.data.data.billRemindsCount
            this.contractRemindsCount = res.data.data.contractRemindsCount
          }
        })
      },
      shows(path) {
      },
      openUrl(path){
        window.open(path)
      },
      urlRedirect(val) {
        const routerList = this.$router.options.routes;
        routerList.forEach((parent) => {
          if (parent.children) {
            parent.children.forEach((child, childIndex, children) => {
              if (child.path === val && child.hidden) {
                this.url = child.from;
                this.netaddress = children[0].path;
              } else if (child.path === val) {
                this.netaddress = child.path;
                this.url = child.path;
              }
            })
          }
        })
      },
    },
    components: {},
    watch: {
      '$route'(val) {
        this.urlRedirect(val.path);
        console.log(this.netaddress + ':::' + this.url)
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .el-menu-item, .el-submenu__title {
    height: 40px;
    line-height: 40px;
    border-left: 3px solid $bg;
    font-size: 12px;
  }

  .el-menu-item span, .el-submenu__title span, .el-submenu__title i {
    font-size: 14px;
    color: $blue;
  }

  .el-menu-item .iconfont, .el-submenu__title .iconfont {
    color: $blue;
    margin-right: 10px;
    font-size: 14px;
  }

  .el-menu-item.is-active, .el-submenu__title.is-active {
    background-color: $active-bg !important;
    border-left: 3px solid $line-color;
  }

  .el-menu-item.is-active span, .el-submenu__title.is-active span {
    color: $fc;
  }

  .el-menu-item.is-active i, .el-submenu__title.is-active i {
    margin-right: 10px;
    font-size: 14px;
    color: $fc;
  }

  .g-elmenu .is-opened .el-submenu__title span {
    color: $blue;
  }

  .g-elmenu .is-opened i {
    color: $blue;
  }

  .remindNumBox {
    padding: 3px 8px;
    height: 16px;
    line-height: 16px;
    background: $red;
    color: #fff;
    display: inline-block;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/left-navbar.vue